import React from "react";
import {
  FaHeartbeat,
  FaAward,
  FaGraduationCap,
  FaStethoscope,
  FaUsers,
} from "react-icons/fa";
import "./About.css";

const About = () => {
  const credentials = [
    "MBBS, MD General Medicine, DM Cardiology",
    "Fellowship in Interventional Cardiology",
    "Board Certified Cardiologist",
    "15+ Years of Clinical Experience",
    "Advanced Training in Complex Cardiac Procedures",
    "Specialized in Interventional Cardiology",
    "ECFMG, FSMB certified (USA)",
    "CASE WESTERN RESERVE UNIVERSITY Post-Doctoral Fellowship, USA",
    "Healthcare Management - Indian School of Business (ISB)",
  ];

  const specializations = [
    "Interventional Cardiology",
    "Preventive Cardiology",
    "Heart Failure Management",
    "Cardiac Imaging & Diagnostics",
    "Electrophysiology",
    "Valvular Heart Disease",
    "Coronary Artery Disease",
    "Hypertension Management",
    "Cardiac Rehabilitation",
    "Emergency Cardiac Care",
  ];

  const achievements = [
    "Featured in Forbes India emagazine 2026 anniversary edition as Healthcare leader in Interventional Cardiology",
    "Winner of the prestigious Shining Star Awards 2026, presented by the National Interventional Council — Cardiological Society of India",
    "Recipient of the Dr. A P J Abdul Kalam Health Awards 2026",
    "Performed 10,000+ Cardiac Procedures",
    "Published 10+ Research Papers",
    "Member of IMA, API, APHRS, ACC",
    "Member of Cardiological Society of India",
    "Speaker at National Cardiology Conferences",
    "Expert in Complex Interventional Procedures",
    "Leader in Preventive Cardiology",
    "Mentor to Young Cardiologists",
    "Contributor to Medical Journals",
    "Recognition for Patient Care Excellence",
    "International Experience at Case Western Reserve University, USA",
    "ECFMG and FSMB Certified for US Medical Practice",
  ];

  const researchPapers = [
    {
      title:
        "Dilemma of Chest Pain in Left Bundle Branch Block Patients Uncovered",
      journal: "Journal of Cardiology & Cardiovascular Therapy",
      year: "2026",
      status: "Published (Jan 2026)",
      url: "https://juniperpublishers.com/jocct/pdf/JOCCT.MS.ID.556032.pdf",
      abstract:
        "Prospective observational study of 100 symptomatic LBBB patients with chest pain or breathlessness. Analyzes angiographic profile: significant CAD in 41%, non-significant in 37%, normal coronaries in 22%. Discusses diagnostic approach and when CAG is indicated in new-onset LBBB.",
      tags: [
        "Left Bundle Branch Block",
        "Coronary Artery Disease",
        "Chest Pain",
        "Heart Failure",
        "Cardiomyopathy",
        "Hypertension",
      ],
    },
    {
      title:
        "Extensive Calcification with Complete Visualization of Coronaries on Fluoroscopy without Contrast – An Interesting Case Overview",
      journal: "Journal of Cardiology & Cardiovascular Therapy",
      year: "2026",
      status: "Published (Jan 2026)",
      url: "https://juniperpublishers.com/jocct/pdf/JOCCT.MS.ID.556031.pdf",
      abstract:
        "Case report of extensive coronary artery calcification with complete visualization of coronaries on fluoroscopy without contrast injection. Discusses pathophysiology, challenges in management of calcific coronaries, and CABG/PCI approach in LMCA and triple vessel disease (SYNTAX score > 22).",
      tags: [
        "Coronary Artery Calcium",
        "CABG",
        "Complex PCI",
        "Fluoroscopy",
        "Coronary Angiogram",
        "Calcific Coronaries",
      ],
    },
    {
      title:
        "Clinical And Angiographic Profile of Women Presenting with Coronary Artery Disease to A Tertiary Cardiac Care Centre",
      journal: "European Journal of Cardiovascular Medicine",
      year: "2025",
      status: "Published (July 2025)",
      url: "https://www.healthcare-bulletin.co.uk/article/clinical-and-angiographic-profile-of-women-presenting-with-coronary-artery-disease-to-a-tertiary-cardiac-care-centre-3865/",
      abstract:
        "Study evaluating the clinical and angiographic characteristics of women with coronary artery disease, focusing on risk factors and disease patterns.",
      tags: [
        "Coronary Artery Disease",
        "Women's Health",
        "Angiography",
        "Gender-Specific Medicine",
        "Cardiovascular Risk Factors",
        "Preventive Cardiology",
      ],
    },
    {
      title:
        "Tiger catheter for difficult femoral artery approach coronary catheterization",
      journal: "Journal of Indian College of Cardiology",
      year: "2024",
      status: "Published (Jan 2024)",
      url: "https://journals.lww.com/jicc/fulltext/2024/14010/tiger_catheter_for_difficult_femoral_artery.4.aspx",
      abstract:
        "Research on the use of Tiger catheter for challenging femoral artery access during coronary catheterization procedures.",
      tags: [
        "Interventional Cardiology",
        "Catheterization",
        "Femoral Access",
        "Coronary Procedures",
        "Vascular Access",
      ],
    },
    {
      title: "Septal Flash in Left Bundle Branch Block Patients",
      journal: "Heart Failure Journal of India",
      year: "2024",
      status: "Published",
      url: "https://journals.lww.com/hfji/fulltext/2024/09000/septal_flash_in_left_bundle_branch_block_patients.5.aspx",
      abstract:
        "Research on the significance and clinical implications of septal flash phenomenon in patients with left bundle branch block.",
      tags: [
        "Left Bundle Branch Block",
        "Septal Flash",
        "Cardiac Imaging",
        "Electrocardiography",
        "Heart Failure",
        "Cardiac Mechanics",
      ],
    },
    {
      title:
        "Postural fall in systolic blood pressure is a useful warning sign in dengue fever",
      journal: "F1000Research",
      year: "2023",
      status: "Published (Dec 2023)",
      url: "https://f1000research.com/articles/12-816",
      abstract:
        "Study examining the clinical significance of postural blood pressure changes as an early warning indicator in dengue fever patients.",
      tags: [
        "Dengue Fever",
        "Blood Pressure",
        "Clinical Signs",
        "Tropical Medicine",
        "Diagnostic Markers",
        "Infectious Diseases",
      ],
    },
    {
      title: "Ivabradine sensitive incessant atrial tachycardia",
      journal: "Indian Heart Journal",
      year: "2021",
      status: "Published (Dec 2021)",
      url: "https://doaj.org/article/8c42ec42c53f413db1387d4a0dfa3d95",
      abstract:
        "Case report on the successful management of persistent atrial tachycardia using ivabradine therapy.",
      tags: [
        "Atrial Tachycardia",
        "Ivabradine",
        "Case Report",
        "Arrhythmia Management",
        "Pharmacotherapy",
        "Electrophysiology",
      ],
    },
    {
      title:
        "Is Post SARS-CoV2 recovery, a catch-22 situation? Review of late cardiac sequelae",
      journal: "Indian Heart Journal",
      year: "2021",
      status: "Published (Nov 2021)",
      url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC8629327/",
      abstract:
        "Comprehensive review of long-term cardiac complications and sequelae following SARS-CoV2 infection and recovery.",
      tags: [
        "COVID-19",
        "Cardiac Sequelae",
        "Long COVID",
        "Post-Viral Complications",
        "Cardiovascular Research",
        "Pandemic Medicine",
      ],
    },
    {
      title: "Rare Presentation of Primary Pulmonary Aspergillosis",
      journal: "Journal of Pulmonary and Respiratory Medicine",
      year: "2014",
      status: "Published (Dec 2014)",
      url: "https://www.hilarispublisher.com/open-access/rare-presentation-of-primary-pulmonary-aspergillosis-2161-105X.1000227.pdf",
      abstract:
        "Case study documenting an unusual clinical presentation of primary pulmonary aspergillosis with diagnostic challenges.",
      tags: [
        "Pulmonary Aspergillosis",
        "Rare Presentation",
        "Case Report",
        "Fungal Infections",
        "Pulmonology",
        "Infectious Diseases",
      ],
    },
    {
      title:
        "Atypical manifestations of Dengue fever …. Where do we stand today?",
      journal: "Journal of Clinical and Diagnostic Research",
      year: "2014",
      status: "Published (Jan 2014)",
      url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC3939591/#:~:text=Atypical%20manifestations%20in%20dengue%20fever,derangement%20was%20most%20often%20seen.",
      abstract:
        "Analysis of unusual and atypical clinical presentations of dengue fever, expanding understanding of the disease spectrum.",
      tags: [
        "Dengue Fever",
        "Atypical Manifestations",
        "Clinical Presentation",
        "Tropical Medicine",
        "Clinical Research",
        "Disease Spectrum",
      ],
    },
  ];

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <div className="about-hero-content">
            <h1 style={{ fontSize: "1.8rem" }}>
              <span style={{ fontWeight: "normal" }}>About</span> Dr. Satya
              Sudhish Nimmagadda
            </h1>
            <p style={{ fontSize: "var(--font-size-base)" }}>
              Interventional Cardiologist & Founder of SATYA HEART CLINIC in
              Hyderabad. Featured in{" "}
              <strong>Forbes India emagazine 2026</strong> anniversary edition
              as Healthcare leader in Interventional Cardiology. Winner of the
              prestigious <strong>Shining Star Awards 2026</strong>, presented
              by the National Interventional Council — Cardiological Society of
              India, and the{" "}
              <strong>Dr. A P J Abdul Kalam Health Awards 2026</strong>.
            </p>
          </div>
        </div>
      </section>

      <div className="container">
        {/* Doctor Profile */}
        <section className="doctor-profile section">
          <div className="profile-header">
            <h2 className="profile-title" style={{ fontSize: "1.8rem" }}>
              Best INTERVENTIONAL CARDIOLOGIST in HYDERABAD
            </h2>
          </div>
          <div className="profile-content">
            <div className="profile-image">
              <img
                src={require("../../assets/doctor-mainpage.jpg")}
                alt="Dr. Satya - Cardiologist"
                className="doctor-photo"
              />
            </div>

            <div className="profile-text">
              <p style={{ marginTop: "2rem", textIndent: "2em" }}>
                Dr. Satya Sudhish Nimmagadda, <strong>founder</strong> and{" "}
                <strong>chief consultant cardiologist</strong> at SATYA HEART
                CLINIC, is recognized as one of the{" "}
                <strong>best INTERVENTIONAL CARDIOLOGISTS in HYDERABAD</strong>.
                He completed his MBBS from Gandhi Medical College, MD in General
                Medicine from Kasturba Medical College, and DM in Cardiology
                from Andhra Medical College. He further trained in{" "}
                <strong>
                  Interventional Cardiology at Yashoda Hospitals (HITEC CITY
                  branch, Hyderabad)
                </strong>
                , gaining expertise in advanced cardiac procedures. He has been
                featured in the{" "}
                <strong>Forbes India emagazine 2026</strong> anniversary edition
                as Healthcare leader in Interventional Cardiology. He is the
                winner of the prestigious{" "}
                <strong>Shining Star Awards 2026</strong>, presented by the
                National Interventional Council — Cardiological Society of
                India, and the{" "}
                <strong>Dr. A P J Abdul Kalam Health Awards 2026</strong>.
              </p>
              <p style={{ textIndent: "2em" }}>
                With extensive clinical experience, Dr. Satya specializes in
                managing hypertension, coronary artery disease, heart failure,
                arrhythmias, valvular disorders, and complex interventional
                treatments. Known for his patient-first approach, he combines
                advanced medical expertise with compassionate care to deliver
                effective, personalized treatment plans.
              </p>
              <p style={{ textIndent: "2em" }}>
                At SATYA HEART CLINIC, Dr. Satya is dedicated to providing
                comprehensive and accessible cardiac care. If you're looking for
                the <strong>best cardiologist in Hyderabad</strong>, Dr. Satya
                Sudhish Nimmagadda is your reliable partner in achieving optimal
                heart health.
              </p>
            </div>
          </div>
        </section>

        {/* Credentials */}
        <section className="credentials-section section">
          <div className="section-header">
            <h2 style={{ fontSize: "1.6rem" }}>
              Professional Credentials & Qualifications
            </h2>
            <p>
              Dr. Satya's comprehensive education, specialized training, and
              extensive experience ensure the highest quality of cardiac care
            </p>
          </div>

          <div className="credentials-grid">
            {credentials.map((credential, index) => (
              <div key={index} className="credential-item">
                <FaGraduationCap className="credential-icon" />
                <span>{credential}</span>
              </div>
            ))}
          </div>
        </section>

        {/* Specializations */}
        <section className="specializations-section section">
          <div className="section-header">
            <h2 style={{ fontSize: "1.6rem" }}>
              Areas of Specialization & Expertise
            </h2>
            <p>
              Comprehensive Interventional Cardiology spanning from preventive
              medicine to complex interventional procedures
            </p>
          </div>

          <div className="specializations-grid">
            {specializations.map((specialization, index) => (
              <div key={index} className="specialization-card">
                <FaStethoscope className="specialization-icon" />
                <h3 style={{ fontSize: "1.3rem" }}>{specialization}</h3>
              </div>
            ))}
          </div>
        </section>

        {/* Achievements */}
        <section className="achievements-section section">
          <div className="section-header">
            <h2 style={{ fontSize: "1.6rem" }}>
              Professional Achievements & Recognition
            </h2>
            <p>
              Recognition of excellence in Interventional Cardiology, research
              contributions, and outstanding patient outcomes
            </p>
          </div>

          <div className="achievements-grid">
            {achievements.map((achievement, index) => (
              <div key={index} className="achievement-item">
                <FaAward className="achievement-icon" />
                <span>{achievement}</span>
              </div>
            ))}
          </div>
        </section>

        {/* Research Papers */}
        <section className="research-papers-section section">
          <div className="section-header">
            <h2 style={{ fontSize: "1.6rem" }}>
              Research Papers & Publications
            </h2>
            <p>
              Contributing to medical knowledge through research and scientific
              publications
            </p>
          </div>

          <div className="research-papers-grid">
            {researchPapers.map((paper, index) => (
              <div key={index} className="research-paper-item">
                <div className="paper-header">
                  <FaGraduationCap className="paper-icon" />
                  <h3>
                    <a
                      href={paper.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="paper-title-link"
                    >
                      {paper.title}
                    </a>
                  </h3>
                </div>
                <p className="paper-journal">{paper.journal}</p>
                <p className="paper-year">{paper.year}</p>
                <p className="paper-status">{paper.status}</p>
                <p className="paper-abstract">{paper.abstract}</p>
                <div className="paper-tags">
                  {paper.tags.map((tag, tagIndex) => (
                    <span key={tagIndex} className="paper-tag">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Clinic Mission */}
        <section className="mission-section section">
          <div className="mission-content">
            <div className="mission-text">
              <h2 style={{ fontSize: "1.6rem" }}>Our Mission</h2>
              <p style={{ textIndent: "2em" }}>
                At SATYA HEART CLINIC, our mission is to provide exceptional
                cardiac care with compassion, expertise, and the latest medical
                technology. We believe that every patient deserves personalized
                attention and the highest standard of medical care.
              </p>
              <p style={{ textIndent: "2em" }}>
                Our commitment extends beyond treating heart conditions to
                preventing them through education, early detection, and
                lifestyle guidance. We strive to be your trusted partner in
                maintaining optimal heart health throughout your life.
              </p>
            </div>

            <div className="mission-image">
              <img
                src={require("../../assets/mission-img.png")}
                alt="Our Mission - SATYA HEART CLINIC"
                className="mission-img"
              />
            </div>
          </div>
        </section>

        {/* Patient Care Philosophy */}
        <section className="philosophy-section section">
          <div className="philosophy-content">
            <h2 style={{ fontSize: "1.6rem" }}>Patient Care Philosophy</h2>
            <p className="philosophy-subtitle">
              Our commitment to excellence in cardiac care is guided by these
              core principles
            </p>
            <div className="philosophy-grid">
              <div className="philosophy-item">
                <FaUsers className="philosophy-icon" />
                <h3 style={{ fontSize: "1.3rem" }}>Patient-Centered Care</h3>
                <p>
                  Every treatment plan is tailored to the individual patient's
                  needs, lifestyle, and preferences, ensuring personalized care
                  for optimal outcomes.
                </p>
              </div>
              <div className="philosophy-item">
                <FaHeartbeat className="philosophy-icon" />
                <h3 style={{ fontSize: "1.3rem" }}>Preventive Approach</h3>
                <p>
                  We focus on preventing heart disease through early detection,
                  education, and lifestyle modifications to maintain long-term
                  heart health.
                </p>
              </div>
              <div className="philosophy-item">
                <FaStethoscope className="philosophy-icon" />
                <h3 style={{ fontSize: "1.3rem" }}>Evidence-Based Medicine</h3>
                <p>
                  All treatments and procedures are based on the latest medical
                  research and clinical guidelines, ensuring the highest
                  standards of care.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
